import styled from 'styled-components';
import { Text } from '@cuemath/web-comps';
export {
  ExportButton,
  PanelExportHeader as TranscriptHeader,
} from './PanelShared.styles';

export const TranscriptWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const TranscriptContainer = styled.div`
  flex: 1;
  overflow-y: auto;
`;

export const TranscriptSegment = styled.div`
  padding: 14px 16px;
  border-radius: 8px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  background: #f5f5f5;
  border: 1px solid #c4c4c4;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 3px;
    height: 100%;
    background: #808080;
    transition: all 0.2s ease;
  }

  &:hover {
    background: #e8e8e8;
    border-color: #9a9a9a;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
    transform: translateX(2px);

    &::before {
      width: 4px;
      background: #5a5a5a;
    }
  }

  ${props =>
    props.isActive &&
    `
    background: #d4d4d4;
    border-color: #5a5a5a;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    
    &::before {
      background: #1a1a1a;
      width: 4px;
    }
    
    &:hover {
      background: #c4c4c4;
      border-color: #1a1a1a;
      box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);
    }
  `}
`;

export const SegmentHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
`;

export const SpeakerBadge = styled.span`
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 9px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  transition: all 0.2s ease;
  background: ${props => {
    switch (props.speaker?.toLowerCase()) {
      case 'student':
        return '#EBBDEC';
      case 'teacher':
      case 'tutor':
        return '#FFC2A2';
      case 'parent':
        return '#AFE8C2';
      case 'unknown':
        return '#c4c4c4';
      default:
        return '#c4c4c4';
    }
  }};
  color: #1a1a1a;
  border: 1px solid
    ${props => {
      switch (props.speaker?.toLowerCase()) {
        case 'student':
          return '#ED6CEF';
        case 'teacher':
        case 'tutor':
          return '#FF7E3B';
        case 'parent':
          return '#3DD771';
        case 'unknown':
          return '#9a9a9a';
        default:
          return '#9a9a9a';
      }
    }};
`;

export const TimeStamp = styled.span`
  font-family: 'SF Mono', 'Monaco', 'Inconsolata', 'Roboto Mono', monospace;
  font-size: 9px;
  font-weight: 500;
  color: #5a5a5a;
  background: #e8e8e8;
  padding: 2px 6px;
  border-radius: 10px;
  border: 1px solid #c4c4c4;
  transition: all 0.2s ease;
`;

export const SegmentText = styled(Text)`
  font-size: 13px;
  line-height: 1.5;
  margin: 0;
  color: #2b2b2b;
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 40px 24px;
  color: #5a5a5a;
  background: #f0f0f0;
  border: 1px solid #c4c4c4;
  border-radius: 8px;
`;
